export default __webpack_public_path__ + "static/media/star-on.967205b9.svg";